module.exports = __webpack_public_path__ + "img/0_7a274a3ab.png";